import { api } from "../client";
import { CampaignExtraFields, CampaignFields } from "../schema/Campaign";
import { Config } from "../types";

type ApiRequestConfig = Config<CampaignFields, CampaignExtraFields>;

export const getCampaigns = async (config?: ApiRequestConfig) => {
  return api.get<CampaignFields, CampaignExtraFields>("campaigns", config);
};

export const getCampaign = (id: number, config?: ApiRequestConfig) => {
  return api.get<CampaignFields, CampaignExtraFields>(
    `campaigns/${id}`,
    config
  );
};
